/**
 * Cheap Location / Predecessor picker active-chrome sync for smart-rendered rows.
 * Picker open state must not rebuild `ganttColumns` / ReactGantt config — paint
 * visible row/cell classes from refs instead (same idea as assign + pending paint).
 */

export function syncPickerActivePaint(
  root: ParentNode,
  locationTaskId: string | null,
  predecessorTaskId: string | null,
): void {
  const locId = locationTaskId != null ? String(locationTaskId) : null;
  const predId = predecessorTaskId != null ? String(predecessorTaskId) : null;

  root
    .querySelectorAll('.gantt_row[data-task-id], .gantt_task_row[data-task-id]')
    .forEach((node) => {
      const el = node as HTMLElement;
      const id = el.getAttribute('data-task-id');
      if (id == null) return;
      el.classList.toggle('gantt-row-location-picker-selected', locId != null && id === locId);
    });

  root.querySelectorAll('.gantt-open-location[data-task-id]').forEach((node) => {
    const el = node as HTMLElement;
    const id = el.getAttribute('data-task-id');
    el.classList.toggle(
      'gantt-open-location-active',
      locId != null && id != null && id === locId,
    );
  });

  root.querySelectorAll('.gantt-open-predecessors[data-task-id]').forEach((node) => {
    const el = node as HTMLElement;
    const id = el.getAttribute('data-task-id');
    el.classList.toggle(
      'gantt-open-predecessors-active',
      predId != null && id != null && id === predId,
    );
  });
}
